import { Interceptor } from 'aurelia-fetch-client';
import { Route } from '../views/app/route';

export class HttpInterceptor403 implements Interceptor {
  async response(response: Response): Promise<Response> {
    if (response.status === 403 && response.headers.get('hasacceptedenduserlicenseagreement') === 'false') {
      window.location.href = Route.acceptEula;
    }

    return response;
  }
}
